module.exports = __webpack_public_path__ + "static/media/img17.d0882876.JPG";